import { all, takeEvery, takeLatest } from 'redux-saga/effects';

import {
  MESSAGES_DETAIL_GET_START,
  MESSAGES_ATTACHMENT_GET_REQUEST,
  MESSAGES_SET_READ_REQUEST,
  MESSAGES_SET_ARCHIVED_REQUEST,
  MESSAGES_ADD_PARTICIPANTS_REQUEST,
  MESSAGES_CREATE_REQUEST,
} from '@store/messages/messagesDetail/messagesDetail.const';
import { MESSAGES_LIST_GET_START } from '@store/messages/messagesList/messagesList.const';
import { RECIPIENTS_GET_REQUEST } from '@store/messages/recipients/recipients.const';

import { handleAddParticipants } from './handleAddParticipantsSaga';
import { handleCreateMessageRequest } from './handleCreateMessageRequestSaga';
import { handleFetchAttachment } from './handleFetchAttachmentSaga';
import { handleGetMessages } from './handleGetMessagesSaga';
import { handleGetMessageThreads } from './handleGetMessageThreadsSaga';
import { handleGetRecipients } from './handleGetRecipientsSaga';
import { handleSetStatusSaga } from './handleSetStatusSaga';

export default all([
  takeLatest(MESSAGES_LIST_GET_START, handleGetMessages),
  takeLatest(MESSAGES_DETAIL_GET_START, handleGetMessageThreads),
  takeEvery(MESSAGES_ATTACHMENT_GET_REQUEST, handleFetchAttachment),
  takeLatest(RECIPIENTS_GET_REQUEST, handleGetRecipients),
  takeEvery(MESSAGES_CREATE_REQUEST, handleCreateMessageRequest),
  takeEvery(MESSAGES_ADD_PARTICIPANTS_REQUEST, handleAddParticipants),
  takeEvery(MESSAGES_SET_READ_REQUEST, handleSetStatusSaga),
  takeEvery(MESSAGES_SET_ARCHIVED_REQUEST, handleSetStatusSaga),
]);
